<div class="row g-0 bn-auth__container">
  <div
    class="bn-auth__side"
    [ngClass]="{
      'col-lg-6': sliderConfig?.length,
      'col-12': !sliderConfig?.length,
    }">
    @if (confirmationCode || (!confirmationCode && !mailSent)) {
      <div class="bn-auth__form">
        <div class="text-center">
          <img
            alt="Bunny.net logo"
            class="bn-auth__logo"
            src="/assets/images/logo-bunnynet-dark-blue.svg" />
          <div class="bn-auth__title">Reset password</div>
          <p class="bn-auth__description">To reset your password, enter your bunny.net account email.</p>
        </div>
        <form
          data-e2e="AuthPagesResetPasswordForm"
          [formGroup]="form"
          (ngSubmit)="onSubmit()">
          <div class="mt-3">
            <bn-web-ui-input
              data-e2e="AuthPagesResetPasswordEmail"
              formControlName="email"
              label="Email"
              placeholder="Email"
              size="md"
              type="text" />
          </div>
          @if (confirmationCode) {
            <div>
              <div class="mt-3">
                <bn-web-ui-input
                  data-e2e="AuthPagesResetPasswordPassword"
                  formControlName="password"
                  label="Password"
                  placeholder="Password"
                  size="md"
                  type="password"
                  [options]="passwordInputSettings" />
              </div>
              <div class="mt-3">
                <bn-web-ui-input
                  data-e2e="AuthPagesResetPasswordConfirmPassword"
                  formControlName="confirmPassword"
                  label="Confirm password"
                  placeholder="Confirm password"
                  size="md"
                  type="password"
                  [options]="passwordInputSettings" />
              </div>
              <div
                class="bn-auth--password-strength my-3 lh-lg p-2"
                [ngClass]="{ 'bn-auth--password-strength--invalid': form.get('password')?.touched && form.get('password')?.invalid }">
                <div>
                  <fa-icon
                    [icon]="form.get('password')?.value?.match('.{12,}') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
                    [ngClass]="{
                      'text-danger-6': !form.get('password')?.value?.match('.{12,}') && form.get('password')?.touched,
                      'text-success-6': form.get('password')?.value?.match('.{12,}'),
                    }" />
                  At least 12 characters long
                </div>
                <div>
                  <fa-icon
                    [icon]="form.get('password')?.value?.match('(?=.*[^A-Za-z\\d])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
                    [ngClass]="{
                      'text-danger-6': !form.get('password')?.value?.match('(?=.*[^A-Za-z\\d])') && form.get('password')?.touched,
                      'text-success-6': form.get('password')?.value?.match('(?=.*[^A-Za-z\\d])'),
                    }" />
                  One special character
                </div>
                <div>
                  <fa-icon
                    [icon]="form.get('password')?.value?.match('(?=.*[a-z])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
                    [ngClass]="{
                      'text-danger-6': !form.get('password')?.value?.match('(?=.*[a-z])') && form.get('password')?.touched,
                      'text-success-6': form.get('password')?.value?.match('(?=.*[a-z])'),
                    }" />
                  One lowercase letter
                </div>
                <div>
                  <fa-icon
                    [icon]="form.get('password')?.value?.match('(?=.*[A-Z])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
                    [ngClass]="{
                      'text-danger-6': !form.get('password')?.value?.match('(?=.*[A-Z])') && form.get('password')?.touched,
                      'text-success-6': form.get('password')?.value?.match('(?=.*[A-Z])'),
                    }" />
                  One uppercase letter
                </div>
                <div>
                  <fa-icon
                    [icon]="form.get('password')?.value?.match('(?=.*[0-9])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
                    [ngClass]="{
                      'text-danger-6': !form.get('password')?.value?.match('(?=.*[0-9])') && form.get('password')?.touched,
                      'text-success-6': form.get('password')?.value?.match('(?=.*[0-9])'),
                    }" />
                  One number
                </div>
              </div>
            </div>
          }
          <div class="mt-5">
            <button
              bn-web-ui-button
              data-e2e="AuthPagesResetPasswordSubmitButton"
              size="xl"
              type="submit"
              [disabled]="isLoading.submit"
              [fullWidth]="true">
              Reset Password
            </button>
          </div>
          <p class="text-center mt-6">
            <a
              class="btn btn-link"
              routerLink="../login"
              >Back to Log In</a
            >
          </p>
        </form>
      </div>
    } @else {
      <div class="bn-auth__form">
        <div class="text-center">
          <img
            alt="Bunny.net logo"
            class="bn-auth__logo"
            src="/assets/images/logo-bunnynet-dark-blue.svg" />
          <div class="bn-auth__title">Email sent</div>
          <p class="bn-auth__description">Please check your email, we have sent you further information.</p>
        </div>
      </div>
    }
  </div>
  @if (sliderConfig?.length) {
    <div class="col-lg-6 d-none d-lg-flex bn-auth__side bn-auth__side--right">
      <bn-auth-content-slider
        [centered]="true"
        [items]="sliderConfig"
        [loading]="isLoading.initial" />
    </div>
  }
</div>
